import { useQuery } from '@tanstack/react-query';
import { awaitJSON, YoutubePlanningLambdaFetch } from '@src/utils/fetch-utils';
import { GoogleAdsAccount } from '../youtube-planning-types';

// The company's Google Ads account + MCC, needed by every Google-backed call on the page. Lives in
// the page shell so it is fetched once per company and shared across tabs (the React Query cache
// keeps it warm across tab unmounts), rather than re-fetched whenever a tab remounts.
export const useGoogleAdsAccount = (cid: string): ReturnType<typeof useQuery<GoogleAdsAccount>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['youtubeGoogleAdsAccount', cid],
    queryFn: async (): Promise<GoogleAdsAccount> => {
      const res = await YoutubePlanningLambdaFetch('/getGoogleAdsAccount', {
        method: 'GET',
        params: { company: cid }
      });
      return awaitJSON<GoogleAdsAccount>(res);
    },
    enabled: Boolean(cid)
  });
